export const VANILLA = "VANILLA LLM";
export const EXCEL = "EXCEL";
export const PDF = "DOCS";
export const NEO4J = "Neo4j";
export const DATABASE = "Database";
export const IMAGE = "IMAGE";
export const PENDING = "pending";
export const APPROVED = "approved";
export const USER = "user";
export const ADMIN = "admin";
export const YOUTUBE = "Youtube";
export const COLLECTION = "COLLECTIONS";
export const PROMPT = "Prompt";
export const DEFAULT_LLM_MODEL = "semantic";
export const FALLBACK_LLM_MODEL = "amazon.nova-pro-v1:0-AI_Team";
